module.exports = __webpack_public_path__ + "img/takeaways.5bd9a6e9.svg";